var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.976,
    height: 15.947,
    viewBox: "0 0 15.976 15.947",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-seat",
    transform: "translate(-8.634 -8.482)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7849",
    "data-name": "Path 7849",
    className: "cls-1",
    d: "M24.5,19.178a2.579,2.579,0,0,0-2.359-1.6h-.032l-6.554-.364-2.139-5.993a4.325,4.325,0,0,0-2.8-2.668,1.537,1.537,0,0,0-1.975,1.643l1.034,8.914a3.23,3.23,0,0,0,3.217,2.881H22.4a2.238,2.238,0,0,0,1.806-.929,2.049,2.049,0,0,0,.292-1.875Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7850",
    "data-name": "Path 7850",
    className: "cls-1",
    d: "M33.753,87.25h-9.1a.4.4,0,1,0,0,.8h9.1a.4.4,0,1,0,0-.8Z",
    transform: "translate(-12.613 -63.621)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7851",
    "data-name": "Path 7851",
    className: "cls-1",
    d: "M51.193,45.93h4.924a.4.4,0,1,0,0-.8H51.193a.4.4,0,1,0,0,.8Z",
    transform: "translate(-34.052 -29.6)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeat);
export default __webpack_public_path__ + "static/media/Seat.60b9f9606107222971a253d694eae9a0.svg";
export { ForwardRef as ReactComponent };